import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

// class PoiEditDialog extends Component {
//
//   constructor(props) {
//     super(props);
//     this.state = {
//       id: this.props.poi.id,
//       title: this.props.poi.title,
//       description: this.props.poi.description,
//       changed: false,
//     };
//     this.handleTitleChange = this.handleChange.bind(this, 'title');
//     this.handleDescChange = this.handleChange.bind(this, 'description');
//     this.onSubmit = this.onSubmit.bind(this);
//     this.onCancel = this.onCancel.bind(this);
//   }
//
//   handleChange(prop, event) {
//     const o = {};
//     o[prop]=event.target.value;
//     o.changed = true;
//     this.setState(o)
//   }
//
//   onSubmit(event) {
//     this.props.onSubmit(this.state)
//   }
//
//   onCancel() {
//     this.setState(Object.assign({}, this.props));
//     this.props.onCancel();
//   }
//
//
// }

function PoiEditDialog(props) {
  const [title, setTitle] = useState(props.title);
  const [description, setDescription] = useState(props.description);

  const actions = [
    <Button label="Cancel" color="primary" onClick={props.onCancel} key={1}>
      Cancel
    </Button>,
    <Button
      variant="contained"
      color="primary"
      label="Submit"
      //keyboardFocused={true}
      onClick={() => {
        props.onSubmit({
          id: props.id,
          title: title,
          description: description
        });
      }}
      key={2}
    >
      Submit
    </Button>
  ];

  return (
    <Dialog
      title="Edit view description"
      actions={actions}
      open={true}
      onClose={props.onCancel}
    >
      <DialogTitle>Edit view description</DialogTitle>
      <DialogContent>
        <TextField
          variant="outlined"
          defaultValue={title}
          label="View title"
          // floatingLabelFixed={true}
          fullWidth={true}
          onChange={() => setTitle(event.target.value)}
          style={{ marginBottom: "16px" }}
        />
        <TextField
          variant="outlined"
          defaultValue={description}
          onChange={() => setDescription(event.target.value)}
          label="View description"
          // floatingLabelFixed={true}
          fullWidth={true}
          multiline
          rowsMax={5}
          rows={5}
        />
      </DialogContent>
      <DialogActions>{actions}</DialogActions>
    </Dialog>
  );
}

export default PoiEditDialog;
